<template>
  <v-tooltip top :disabled="!$slots.tooltip">
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        :size="size"
        :color="color"
        :class="
          textColor +
            '--text ' +
            (cssClass || '') +
            (borderColor ? ' border--' + borderColor : '') +
            (borderStyle ? ' border--' + borderStyle : '')
        "
        @click="$emit('click', $event)"
        v-bind="attrs"
        v-on="on"
      >
        <img v-if="avatarUrl" :src="avatarUrl" :alt="name" />
        <inline-svg v-else-if="badgeUrl" :fill="fill" :src="badgeUrl" />
        <v-icon v-else-if="icon" :color="iconColor || 'white'" :size="iconSize">
          {{ icon }}
        </v-icon>
        <template v-else>
          {{
            (name || " ")
              .split(" ")
              .map(x => (x[0] || "").toUpperCase())
              .join("")
              .slice(0, 2)
          }}
        </template>
      </v-avatar>
    </template>
    <span class="pa-2">
      <slot name="tooltip"></slot>
    </span>
  </v-tooltip>
</template>

<script>
import InlineSvg from "vue-inline-svg";
export default {
  name: "Avatar",
  components: { InlineSvg },
  props: {
    color: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    cssClass: {
      type: String,
      default: ""
    },
    avatarUrl: {
      type: String,
      default: ""
    },
    size: {
      type: [Number, String],
      default: 20
    },
    borderColor: {
      type: String,
      default: ""
    },
    icon: { type: String, default: "" },
    iconSize: { type: Number, default: 40 },
    iconColor: { type: String, default: "white" },
    badgeUrl: { type: String, default: "" },
    fill: { type: String, default: "" },
    textColor: { type: String, default: "white" },
    borderStyle: { type: String, default: "2" }
  }
};
</script>

<style lang="scss" scoped>
.v-avatar {
  &.halo {
    img {
      padding: 6px;
    }
  }
}

::v-deep .cls-1 {
  fill: inherit !important;
}
</style>
